import React, { useEffect, useState } from 'react';
import { ShoppingCart, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../../../contexts/CartContext';


const Icons: React.FC = () => {
  const navigate = useNavigate();
  const { getCartItemCount } = useCart();
  const [, setIsMobile] = useState(window.innerWidth <= 768);
  
  // Check if current route is product details page or auth page

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cartCount = getCartItemCount();

  const handleCartClick = () => {
    navigate('/cart');
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  // Wishlist icon removed


  return (
    <>
      {/* Desktop/Tablet Header Icons */}
      <div className="header-icons">
        {/* {isMobile && (isProductDetailsPage || isAuthPage || isViewProductsPage) && (
          <div 
            className="icon-item" 
            onClick={handleSearchClick} 
            style={{ cursor: 'pointer' }}
          >
            <Search className="icon" />
            <span className="icon-text">Search</span>
          </div>
        )} */}

        <div 
          className="icon-item icon-with-badge cart-icon-desktop" 
          onClick={handleCartClick} 
          style={{ cursor: 'pointer' }}
        >
          <ShoppingCart className="icon" />
          <span className="icon-text">Cart</span>
          {cartCount > 0 && (
            <span className="icon-badge">{cartCount}</span>
          )}
        </div>

        <div 
          className="icon-item profile-icon" 
          onClick={handleProfileClick} 
          style={{ cursor: 'pointer' }}
        >
          <User className="icon" />
          <span className="icon-text">User</span>
        </div>
      </div>
    </>
  );
};

export default Icons;